var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 112C86.928 112 112 86.928 112 56C112 25.0721 86.928 0 56 0C25.0721 0 0 25.0721 0 56C0 86.928 25.0721 112 56 112Z",
    fill: "url(#paint0_linear_1493_77717)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0001 109.538C85.5687 109.538 109.539 85.568 109.539 55.9995C109.539 26.431 85.5687 2.46094 56.0001 2.46094C26.4316 2.46094 2.46161 26.431 2.46161 55.9995C2.46161 85.568 26.4316 109.538 56.0001 109.538Z",
    fill: "url(#paint1_linear_1493_77717)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99.4877C80.0175 99.4877 99.4876 80.0176 99.4876 56.0001C99.4876 31.9825 80.0175 12.5125 56 12.5125C31.9825 12.5125 12.5124 31.9825 12.5124 56.0001C12.5124 80.0176 31.9825 99.4877 56 99.4877Z",
    fill: "url(#paint2_linear_1493_77717)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 95.5864C77.8623 95.5864 95.5852 77.8635 95.5852 56.0011C95.5852 34.1388 77.8623 16.4159 56 16.4159C34.1377 16.4159 16.4148 34.1388 16.4148 56.0011C16.4148 77.8635 34.1377 95.5864 56 95.5864Z",
    fill: "url(#paint3_linear_1493_77717)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0775 64.5244C17.0775 64.5244 23.6935 95.6992 55.7733 95.6992C87.8546 95.6992 94.9225 64.5244 94.9225 64.5244C94.9225 64.5244 86.4949 94.5661 55.7733 93.8863C25.0518 93.2078 17.0775 64.5244 17.0775 64.5244Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.3032 61.3161C93.6709 59.2039 93.8647 57.0303 93.8647 54.8126C93.8647 34.0109 77.001 17.1472 56.1993 17.1472C35.3976 17.1472 18.5339 34.0109 18.5339 54.8126C18.5339 57.3083 18.7791 59.7455 19.2423 62.1043C57.8726 66.8761 82.7263 63.4868 93.3032 61.3161Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.385 60.4623C11.2254 58.8888 10.8932 56.5386 10.9232 54.9237C11.3849 30.6159 30.301 10.2845 56.208 10.4627C78.616 10.6166 99.4876 26.9245 101.333 54.1555C101.453 55.92 101.114 58.7449 100.923 60.4637C103.847 59.8452 107.06 58.591 107.76 57.7985C107.801 56.9476 107.824 56.0925 107.824 55.2302C107.824 26.6095 84.5751 4.46375 55.953 4.46375C27.3309 4.46375 4.17743 26.6095 4.17743 55.2302C4.17743 56.1081 4.20026 56.9804 4.24302 57.847C6.54767 59.905 9.36967 59.8295 11.385 60.4623Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9994 99.4881C59.9994 99.4881 87.3844 99.5565 96.9308 70.7191C85.0769 98.3079 59.9994 99.4881 59.9994 99.4881Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94115 34.5372C6.94115 34.5372 19.0216 5.84811 44.2858 3.75012C21.0769 7.5399 6.94115 34.5372 6.94115 34.5372Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1493_77717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5126 78.0325C39.0405 78.0325 37.0365 76.0284 37.0365 73.5563V35.0347C37.0365 32.5626 39.0405 30.5586 41.5126 30.5586C43.9846 30.5586 45.9887 32.5626 45.9887 35.0347V41.3419C45.9887 46.2112 49.936 50.1585 54.8052 50.1585C59.6745 50.1585 63.6218 46.2112 63.6218 41.3419V35.0347C63.6218 32.5626 65.6258 30.5586 68.0979 30.5586C70.57 30.5586 72.574 32.5626 72.574 35.0347V73.5564C72.574 76.0284 70.57 78.0325 68.0979 78.0325C65.6258 78.0325 63.6218 76.0284 63.6218 73.5564V67.1135C63.6218 62.2442 59.6745 58.2969 54.8052 58.2969C49.936 58.2969 45.9887 62.2442 45.9887 67.1135V73.5563C45.9887 76.0284 43.9846 78.0325 41.5126 78.0325Z",
    fill: "#6C5302",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1493_77717",
    x: 37.0365,
    y: 19.4106,
    width: 35.5376,
    height: 58.6218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -27.8699
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.57398
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1493_77717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1493_77717",
    x1: 56,
    y1: 0.000855158,
    x2: 56,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D47800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1493_77717",
    x1: 56.0002,
    y1: 2.46179,
    x2: 56.0002,
    y2: 109.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    stopColor: "#E9C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    stopColor: "#FFD215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1493_77717",
    x1: 56,
    y1: 99.4875,
    x2: 56,
    y2: 12.5136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    stopColor: "#E9C300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1493_77717",
    x1: 55.9998,
    y1: 16.4166,
    x2: 55.9998,
    y2: 95.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3194,
    stopColor: "#E9CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7016,
    stopColor: "#DDA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameCoin);
export default __webpack_public_path__ + "static/media/gameCoin.bc38c3611d82960fed4799adf26ab0a6.svg";
export { ForwardRef as ReactComponent };